export default __webpack_public_path__ + "static/media/ME.e744e4f3.svg";